export default {
  GET_PREVIEW: 'getPreview',
  REMOVE_RENDITION: 'removeRendition',
}
